module.exports = __webpack_public_path__ + "img/04.230e5608.jpg";